import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { AuthMutationRequest, AuthMutationResponse, AuthHeaderParams } from "../../types/Auth";

/**
     * @summary Попытка авторизации
     * @link /api/auth/token
     */
export async function auth (data: AuthMutationRequest, headers?: AuthHeaderParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<AuthMutationResponse>["data"]> {
    const { data: resData } = await client<AuthMutationResponse, AuthMutationRequest>({
        method: "post",
        url: `/api/auth/token`,
        data,
        headers: { ...headers, ...options.headers },
        ...options
    });
    
    return resData;
};